import {forwardRef, SVGAttributes} from 'react';

export const ChevronIcon = forwardRef<SVGSVGElement, SVGAttributes<SVGElement>>((props, ref) => (
	<svg
		width='9'
		height='13'
		viewBox='0 0 9 13'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
		ref={ref}
	>
		<path
			d='M8.38635 11.3289L3.80635 6.73886L8.38635 2.14886L6.97635 0.738861L0.976349 6.73886L6.97635 12.7389L8.38635 11.3289Z'
			fill='white'
		/>
	</svg>
));
